import React from 'react';

var styles = {"ltr":"_5fRtN","rtl":"L2lo1","iconContainer":"Qgcxu","icon":"Rh1Jd","isExpanded":"phmA7","listDimensions":"jFeov"};

var CollapsibleListContext = /*#__PURE__*/React.createContext(null);
var CollapsibleListContextProvider = function CollapsibleListContextProvider(_ref) {
  var expandedItemId = _ref.expandedItemId,
    setExpandedItemId = _ref.setExpandedItemId,
    children = _ref.children;
  return /* @__PURE__ */React.createElement(CollapsibleListContext.Provider, {
    value: {
      expandedItemId: expandedItemId,
      setExpandedItemId: setExpandedItemId
    }
  }, children);
};

export { CollapsibleListContextProvider as C, CollapsibleListContext as a, styles as s };

import 'wix-rich-content-plugin-collapsible-list/dist/loadable/viewer/es/styles.viewer.min.global.css'